export default __webpack_public_path__ + "static/media/powershell.661a2e90.svg";